module.exports = __webpack_public_path__ + "img/Lego.0d121e7f.svg";